export var DependencyTypes;
(function (DependencyTypes) {
    DependencyTypes["SEARCH"] = "search";
    DependencyTypes["SITEMAP_GENERATOR"] = "sitemap-generator";
})(DependencyTypes || (DependencyTypes = {}));
